import qs from 'qs';
import { useQueryClient } from 'react-query';
import { useFranchise } from '~/shared/utils';

export const useAlgoliaInitialState = (url: string) => {
    const { queryKey } = useFranchise();
    const queryClient = useQueryClient();
    const [path, query] = url.split('?');
    const keys = qs.parse(query);

    const removeInitialState = () => {
        queryClient.removeQueries(['algolia', { queryKey, path, keys }]);
    };

    return {
        initialState: queryClient.getQueryData(['algolia', { queryKey, path, keys }]),
        removeInitialState,
    };
};
